import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewEncapsulation
} from '@angular/core';

import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import {
  DeviceService, IconSizeEnum, IProductCustomer, IWarranty, SdBorderWrapperComponent, SdListComponent,
  SdProductCustomerComponent, SdHtmlComponent, SdTitleComponent
} from '@seb/web-design-system/core';

import { SdWarrantyCheckboxGroupComponent, SdWarrantyInformationsComponent } from '@seb/web-design-system/warranty';

import { CheckoutStepsEnum } from '../checkout-steps.enum';
import { SdIconComponent } from '../../../core/src/lib/components/icons/icon/icon.component';

@Component({
  selector: 'sd-checkout-orders',
  templateUrl: './checkout-orders.component.html',
  styleUrls: ['./checkout-orders.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdBorderWrapperComponent,
    SdListComponent,
    SdProductCustomerComponent,
    SdTitleComponent,
    SdWarrantyCheckboxGroupComponent,
    SdWarrantyInformationsComponent,
    TranslateModule,
    SdHtmlComponent,
    SdIconComponent
  ]
})
export class SdCheckoutOrdersComponent implements OnInit, OnChanges, OnDestroy {
  constructor(
    private readonly cdRef: ChangeDetectorRef,
    private readonly deviceService: DeviceService
  ) {}

  iconSizeEnum = IconSizeEnum;
  checkoutStepsEnum = CheckoutStepsEnum;
  mobileSubscription: Subscription;
  isMobile$: boolean;
  atLeastOneLowStockProduct = false;

  @Input()
  titleLevel = 4;

  @Input()
  promo: string;

  @Input()
  isReadOnly = false;

  @Input()
  quantityDisabled = false;

  @Input()
  canAddToWishList = true;

  @Input()
  isOverview = true;

  @Input()
  productsList: IProductCustomer[];

  @Input()
  totalProducts: number;

  @Input()
  isActiveBrand: boolean;

  @Input()
  step: CheckoutStepsEnum;

  @Output()
  favorite = new EventEmitter<string>();

  @Output()
  delete = new EventEmitter<string>();

  @Output()
  quantity = new EventEmitter<{ product: string; qty: number }>();

  @Output()
  openRecommendedPriceModal = new EventEmitter<void>();

  @Output()
  selectWarranty = new EventEmitter<IWarranty>();

  ngOnInit() {
    this.mobileSubscription = this.deviceService.isMobile.subscribe((x) => {
      this.isMobile$ = x;
      this.cdRef.markForCheck();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.productsList?.currentValue !== changes?.productsList?.previousValue) {
      this.atLeastOneLowStockProduct = this.productsList.some((product) => product?.stock?.lowStock);
    }
  }

  ngOnDestroy() {
    this.mobileSubscription?.unsubscribe();
  }

  onDelete(product: string) {
    this.delete.emit(product);
  }

  onFavorite(product: string) {
    this.favorite.emit(product);
  }

  trackByProductCode(index: number, product: IProductCustomer): string {
    return product.code;
  }

  onQuantityChange(product: string, qty: number) {
    this.quantity.emit({ product, qty });
  }

  onopenRecommendedPriceModal() {
    this.openRecommendedPriceModal.emit();
  }

  onClickWarranty(warranty: IWarranty) {
    this.selectWarranty.emit(warranty);
  }
}
